import Loader from "./components/Loader.jsx";
import Home from "./pages/Home.jsx";
import { useLoading } from "./context/LoaderContext.jsx";

function App() {
  const { isLoading } = useLoading();

  return (
    <div className="h-screen">
      {isLoading ? <Loader /> : <Home/>}
     
    </div>
  );
}

export default App;
